import { render, staticRenderFns } from "./back-index.vue?vue&type=template&id=a97eb128&scoped=true&"
import script from "./back-index.vue?vue&type=script&lang=js&"
export * from "./back-index.vue?vue&type=script&lang=js&"
import style0 from "./back-index.vue?vue&type=style&index=0&id=a97eb128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97eb128",
  null
  
)

export default component.exports